import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import $ from 'jquery'

const createColoredIcon = (color) => L.divIcon({
  className: '',
  html: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 36" width="24" height="36">
      <path fill="${color}" d="M12 0C5.37 0 0 5.37 0 12c0 9 12 24 12 24s12-15 12-24C24 5.37 18.63 0 12 0z"/>
      <circle cx="12" cy="12" r="5" fill="white"/>
    </svg>
  `,
  iconAnchor: [12, 36],
  popupAnchor: [0, -36]
})

class MapModule {
  constructor (selector) {
    this.selector = selector
    this.maps = []
    this.markers = []
    return this
  }

  checkElement () {
    return !!this.selector.length
  }

  loadAPI () {
    // Leaflet ne nécessite pas de chargement asynchrone
    this.process()
  }

  process () {
    $.map(this.selector, (elem) => {
      const $elem = $(elem)
      const markersData = $elem.data('marker') || []

      // Création de la carte
      const map = L.map(elem, {
        center: [46.8, 2.5], // centre par défaut sur la France
        zoom: 6,
        scrollWheelZoom: false
      })

      // Ajout des tuiles OpenStreetMap
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
      }).addTo(map)

      // Stocke la carte
      this.maps.push(map)

      // Création des marqueurs
      const mapMarkers = markersData.map(marker => {
        let popupContent

        const color = (marker.category === 0 || marker.category === 1)
          ? '#0cc' // bleu
          : '#e55c5c' // rouge

        const icon = createColoredIcon(color)

        if (marker.category === 0 || marker.category === 1) {
          popupContent = `
            <div class="corporate-primary" style="margin: 10px; font-weight: bold">
              <span class="icomoon-encre mr-2"></span>
              ${marker.location.name.fr}
            </div>
          `
        } else {
          popupContent = `
            <div class="corporate-primary" style="margin: 10px; font-weight: bold">
              <span class="icomoon-voile mr-2"></span>
              ${marker.location.name.fr}
            </div>
          `
        }


        // Création du marqueur
        const mapMarker = L.marker(
          [marker.location.latitude, marker.location.longitude],
          { icon }
        ).addTo(map)

        mapMarker.bindPopup(popupContent)

        return mapMarker
      })

      this.markers.push(...mapMarkers)
      this.fitMap(map, mapMarkers)
    })
  }

  run () {
    if (this.checkElement()) {
      this.selector.css('z-index', '0');
      this.loadAPI()
    }
  }

  fitMap (map, markers) {
    if (!markers.length) return
    const bounds = L.latLngBounds(markers.map(m => m.getLatLng()))
    map.fitBounds(bounds)
  }
}

export default MapModule



// WEBPACK FOOTER //
// ./activity/static/activity/js/map-leaflet.js